define.alias("shared/components/shared/modal/header", "settings/components/shared/modal/header");